import styled from '@emotion/styled'
import { css, keyframes } from '@emotion/react'

const spotlightShieldPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 204, 0, 0.55);
    border-color: rgba(255, 204, 0, 1);
  }

  100% {
    box-shadow: 0 0 0 10px rgba(255, 204, 0, 0);
    border-color: rgba(255, 204, 0, 0.95);
  }
`

export const Overlay = styled.div<{ elevated?: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${({ elevated }) => (elevated ? 10050 : 9999)};
  pointer-events: auto;
`

export const OverlaySvg = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`

export const SpotlightShield = styled.div<{
  elevated?: boolean
  $isPulsing?: boolean
}>`
  position: fixed;
  z-index: ${({ elevated }) => (elevated ? 10050 : 10000)};
  border: 2px dashed rgba(255, 204, 0, 0.95);
  border-radius: 12px;
  background: rgba(255, 204, 0, 0.08);
  cursor: default;
  box-sizing: border-box;
  animation: ${({ $isPulsing }) =>
    $isPulsing
      ? css`
          ${spotlightShieldPulse} 0.45s ease-out
        `
      : 'none'};
`
